import systemSettingApi from '@/api/system-setting'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  defaultCountryId: 0,
  countries: [],
  countriesFailed: false,
  errors: {
    errors: [],
    commonErrors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  fetch({ commit }) {
    commit('FORM_RESET')

    return systemSettingApi.getCrmSetting()
      .then(({ data }) => commit('CRM_SETTING_FETCHED', data))
      .catch(err => commit('CRM_SETTING_FETCH_FAILED', err))
  },
  fetchCountries({ commit }) {
    return systemSettingApi.getCrmCountries()
      .then(({ data }) => commit('CRM_COUNTRIES_FETCHED', data))
      .catch(() => commit('CRM_COUNTRIES_FAILED'))
  },
  update({ commit }) {
    return systemSettingApi.saveCrmSetting({ defaultCountryId: Number(state.defaultCountryId) })
      .then(({ data }) => commit('CRM_SETTING_UPDATED', data))
      .catch(error => {
        commit('CRM_SETTING_UPDATE_FAILED', error.response.data)
        throw error
      })
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const mutations = {
  CRM_SETTING_UPDATED() {
    store.dispatch('message/success', 'APPLICATION_DESCRIPTION.updated')
  },
  CRM_SETTING_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedUpdate')
  },
  CRM_SETTING_FETCH_FAILED() {
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.failedUpdate')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  CRM_SETTING_FETCHED(state, data) {
    Object.assign(state, data)
  },
  CRM_COUNTRIES_FETCHED(state, data) {
    state.countries = data
    state.countriesFailed = false
  },
  CRM_COUNTRIES_FAILED(state) {
    state.countries = []
    state.countriesFailed = true
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
